import React, { Component } from "react";
import axios from "../../utils/axiosInstance";
import Swal from "sweetalert2";
import "./Bookings.css";

class Bookings extends Component {
  state = {
    bookings: [],
    customers: [],
    posts: [],
    formData: {
      id: null,
      post_id: "",
      customer_id: "",
      checkin_date: "",
      checkout_date: "",
      rooms: "",
      adults: "",
      kids: "",
      remarks: "",
      total_amount: "",
      booking_status: "pending",
      payment_status: "unpaid",
    },
    deleteId: null,
    error: "",
    loading: false,
    submitting: false,
    modalMode: "add",
    currentPage: 1,
    itemsPerPage: 10,
    searchTerm: "",
  };

  componentDidMount() {
    this.fetchBookings();
    this.fetchCustomers();
    this.fetchPosts();

    this.bookingModalEl = document.getElementById("bookingModal");
    if (this.bookingModalEl) {
      this.bookingModalEl.addEventListener("hidden.bs.modal", this.resetForm);
    }
  }

  componentWillUnmount() {
    if (this.bookingModalEl) {
      this.bookingModalEl.removeEventListener("hidden.bs.modal", this.resetForm);
    }
  }

  fetchBookings = async () => {
    this.setState({ loading: true, error: "" });
    try {
      const res = await axios.get("/bookings");
      const data = res.data?.data || [];
      this.setState({ bookings: Array.isArray(data) ? data : [], currentPage: 1 });
    } catch (err) {
      this.setState({ error: err.response?.data?.message || "Failed to load bookings." });
    } finally {
      this.setState({ loading: false });
    }
  };

  fetchCustomers = async () => {
    try {
      const res = await axios.get("/customers");
      this.setState({ customers: Array.isArray(res.data?.data) ? res.data.data : [] });
    } catch (err) {
      console.error("Error fetching customers", err);
    }
  };

  fetchPosts = async () => {
    try {
      const res = await axios.get("/posts");
      this.setState({ posts: Array.isArray(res.data?.data) ? res.data.data : [] });
    } catch (err) {
      console.error("Error fetching posts", err);
    }
  };

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState((prev) => ({
      formData: { ...prev.formData, [name]: value },
      error: "",
    }));
  };

  resetForm = () => {
    this.setState({
      formData: {
        id: null,
        post_id: "",
        customer_id: "",
        checkin_date: "",
        checkout_date: "",
        rooms: "",
        adults: "",
        kids: "",
        remarks: "",
        total_amount: "",
        booking_status: "pending",
        payment_status: "unpaid",
      },
      error: "",
      submitting: false,
      modalMode: "add",
    });
  };

  openModal = (mode = "add", booking = null) => {
    const modalEl = document.getElementById("bookingModal");
    if (!modalEl || !window.bootstrap) return;

    if (mode === "edit" && booking) {
      this.setState({
        modalMode: "edit",
        formData: {
          id: booking.id ?? null,
          post_id: booking.post_id ?? "",
          customer_id: booking.customer_id ?? "",
          checkin_date: booking.checkin_date ?? "",
          checkout_date: booking.checkout_date ?? "",
          rooms: booking.rooms ?? "",
          adults: booking.adults ?? "",
          kids: booking.kids ?? "",
          remarks: booking.remarks ?? "",
          total_amount: booking.total_amount ?? "",
          booking_status: booking.booking_status ?? "pending",
          payment_status: booking.payment_status ?? "unpaid",
        },
        error: "",
      });
    } else {
      this.resetForm();
    }

    window.bootstrap.Modal.getOrCreateInstance(modalEl).show();
  };

  handleSubmit = async (e) => {
    e.preventDefault();
    const { formData, modalMode } = this.state;

    if (!formData.post_id || !formData.customer_id) {
      this.setState({ error: "Post and Customer are required." });
      return;
    }

    this.setState({ submitting: true, error: "" });

    try {
      const token = localStorage.getItem("token");
      const config = { headers: { Authorization: `Bearer ${token}` } };

      if (modalMode === "add") {
        await axios.post("/bookings", formData, config);
      } else {
        await axios.put(`/bookings/${formData.id}`, formData, config);
      }

      await this.fetchBookings();

      const modalEl = document.getElementById("bookingModal");
      if (modalEl && window.bootstrap) {
        const modal = window.bootstrap.Modal.getInstance(modalEl);
        if (modal) modal.hide();
      }

      Swal.fire({
        icon: "success",
        title: modalMode === "add" ? "Booking created successfully!" : "Booking updated successfully!",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (err) {
      this.setState({ error: err.response?.data?.message || "Error saving booking." });
    } finally {
      this.setState({ submitting: false });
    }
  };

  confirmDelete = (id) => {
    this.setState({ deleteId: id });
    const modalEl = document.getElementById("deleteModal");
    if (!modalEl || !window.bootstrap) return;
    window.bootstrap.Modal.getOrCreateInstance(modalEl).show();
  };

  handleDelete = async () => {
    const { deleteId } = this.state;
    if (!deleteId) return;

    try {
      await axios.delete(`/bookings/${deleteId}`);
      await this.fetchBookings();

      const modalEl = document.getElementById("deleteModal");
      if (modalEl && window.bootstrap) {
        const modal = window.bootstrap.Modal.getInstance(modalEl);
        if (modal) modal.hide();
      }

      this.setState({ deleteId: null });
      Swal.fire({
        icon: "success",
        title: "Booking deleted successfully!",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Failed to delete booking.",
        text: err.response?.data?.message || "Please try again.",
      });
    }
  };

  handleSearchChange = (e) => {
    this.setState({
      searchTerm: e.target.value,
      currentPage: 1,
    });
  };

  clearSearch = () => {
    this.setState({
      searchTerm: "",
      currentPage: 1,
    });
  };

  getFilteredBookings = () => {
    const { bookings, searchTerm } = this.state;
    const query = String(searchTerm || "").trim().toLowerCase();

    if (!query) return bookings;

    return bookings.filter((booking) => {
      const searchableText = [
        booking.id,
        booking.full_name,
        booking.customer_id,
        booking.post_title,
        booking.post_id,
        booking.checkin_date,
        booking.checkout_date,
        booking.total_amount,
        booking.booking_status,
        booking.payment_status,
      ]
        .filter((value) => value !== null && value !== undefined)
        .join(" ")
        .toLowerCase();

      return searchableText.includes(query);
    });
  };

  handlePageChange = (page) => {
    const { itemsPerPage } = this.state;
    const totalPages = Math.ceil(this.getFilteredBookings().length / itemsPerPage);
    if (page < 1 || page > totalPages) return;
    this.setState({ currentPage: page });
  };

  handleItemsPerPageChange = (e) => {
    this.setState({ itemsPerPage: Number(e.target.value), currentPage: 1 });
  };

  getPageNumbers = () => {
    const { itemsPerPage, currentPage } = this.state;
    const totalPages = Math.ceil(this.getFilteredBookings().length / itemsPerPage);

    if (totalPages <= 7) {
      return Array.from({ length: totalPages }, (_, index) => index + 1);
    }

    const pages = [1];
    if (currentPage > 3) pages.push("...");

    const start = Math.max(2, currentPage - 1);
    const end = Math.min(totalPages - 1, currentPage + 1);

    for (let page = start; page <= end; page++) pages.push(page);
    if (currentPage < totalPages - 2) pages.push("...");
    pages.push(totalPages);
    return pages;
  };

  truncateText = (text, length = 30) => {
    if (!text) return "N/A";
    return text.length > length ? `${text.substring(0, length)}...` : text;
  };

  formatCurrency = (amount) => {
    const number = Number(amount);
    return Number.isNaN(number)
      ? amount || "0"
      : number.toLocaleString("en-BD", { maximumFractionDigits: 2 });
  };

  formatDate = (date) => {
    if (!date) return "N/A";
    const parsed = new Date(date);
    if (Number.isNaN(parsed.getTime())) return date;
    return parsed.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  bookingStatus = (status) => {
    const value = String(status || "pending").toLowerCase();
    const config = {
      confirmed: ["confirmed", "ph-check-circle"],
      cancelled: ["cancelled", "ph-x-circle"],
      canceled: ["cancelled", "ph-x-circle"],
      pending: ["pending", "ph-clock"],
    }[value] || [value, "ph-clock"];

    return (
      <span className={`booking-status ${config[0]}`}>
        <i className={`ph ${config[1]}`}></i>
        {status || "pending"}
      </span>
    );
  };

  paymentStatus = (status) => {
    const paid = String(status || "unpaid").toLowerCase() === "paid";
    return (
      <span className={`booking-status ${paid ? "paid" : "unpaid"}`}>
        <i className={`ph ${paid ? "ph-check-circle" : "ph-warning-circle"}`}></i>
        {status || "unpaid"}
      </span>
    );
  };

  render() {
    const {
      bookings,
      customers,
      posts,
      formData,
      error,
      loading,
      submitting,
      modalMode,
      currentPage,
      itemsPerPage,
      searchTerm,
    } = this.state;

    const filteredBookings = this.getFilteredBookings();
    const totalItems = filteredBookings.length;
    const totalPages = Math.ceil(totalItems / itemsPerPage);
    const startIndex = totalItems ? (currentPage - 1) * itemsPerPage : 0;
    const endIndex = Math.min(startIndex + itemsPerPage, totalItems);
    const currentBookings = filteredBookings.slice(startIndex, endIndex);

    const paidCount = filteredBookings.filter((b) => String(b.payment_status).toLowerCase() === "paid").length;
    const pendingCount = filteredBookings.filter((b) => String(b.booking_status).toLowerCase() === "pending").length;

    return (
      <div className="pc-container bookings-management">
        <div className="pc-content">
          <div className="row">
            <div className="col-12">
              <div className="booking-page-card">
                <div className="booking-page-header">
                  <div>
                    <div className="booking-breadcrumb">
                      <span>Booking</span>
                      <i className="ph ph-caret-right"></i>
                      <span className="active">List</span>
                    </div>
                    <h4 className="booking-page-title">Booking Management</h4>
                    <p className="booking-page-subtitle">
                      Manage reservations, customers, payments and booking status.
                    </p>
                  </div>
                  <button type="button" className="booking-add-btn" onClick={() => this.openModal("add")}>
                    <i className="ph ph-plus"></i>
                    <span>New Booking</span>
                  </button>
                </div>

                <div className="booking-summary-bar">
                  <div className="booking-summary-item">
                    <span className="booking-summary-icon"><i className="ph ph-calendar-check"></i></span>
                    <div><small>Total Bookings</small><strong>{totalItems}</strong></div>
                  </div>
                  <div className="booking-summary-item">
                    <span className="booking-summary-icon"><i className="ph ph-credit-card"></i></span>
                    <div><small>Paid</small><strong>{paidCount}</strong></div>
                  </div>
                  <div className="booking-summary-item">
                    <span className="booking-summary-icon"><i className="ph ph-clock"></i></span>
                    <div><small>Pending</small><strong>{pendingCount}</strong></div>
                  </div>
                </div>

                <div className="booking-toolbar">
                  <div className="booking-toolbar-left">
                    <div className="booking-search-box">
                      <i className="ph ph-magnifying-glass"></i>
                      <input
                        type="search"
                        value={searchTerm}
                        onChange={this.handleSearchChange}
                        placeholder="Search booking, customer, post, status..."
                        aria-label="Search bookings"
                      />
                      {searchTerm && (
                        <button
                          type="button"
                          className="booking-search-clear"
                          onClick={this.clearSearch}
                          aria-label="Clear search"
                          title="Clear search"
                        >
                          <i className="ph ph-x"></i>
                        </button>
                      )}
                    </div>
                  </div>

                  <div className="booking-toolbar-result">
                    {searchTerm ? (
                      <>
                        <span>Search results</span>
                        <strong>{totalItems}</strong>
                      </>
                    ) : (
                      <>
                        <span>Total</span>
                        <strong>{totalItems}</strong>
                      </>
                    )}
                  </div>
                </div>

                <div className="booking-table-section">
                  {error && (
                    <div className="booking-alert">
                      <i className="ph ph-warning-circle"></i><span>{error}</span>
                    </div>
                  )}

                  {loading ? (
                    <div className="booking-loading">
                      <div className="spinner-border" role="status"><span className="visually-hidden">Loading...</span></div>
                      <p>Loading bookings...</p>
                    </div>
                  ) : (
                    <>
                      <div className="booking-table-wrapper">
                        <table className="booking-table">
                          <thead>
                            <tr>
                              <th className="col-id">#ID</th>
                              <th className="col-customer">Customer</th>
                              <th className="col-post">Post Title</th>
                              <th className="col-date">Check-in / Out</th>
                              <th className="col-amount">Amount</th>
                              <th className="col-status">Status</th>
                              <th className="col-payment">Payment</th>
                              <th className="col-actions">Actions</th>
                            </tr>
                          </thead>
                          <tbody>
                            {currentBookings.length ? currentBookings.map((b) => (
                              <tr key={b.id}>
                                <td className="booking-id-cell">
                                  BK-{b.booking_date.split(' ')[0].replace(/-/g, '')}-{b.id}
                                </td>
                                <td>
                                  <div className="customer-cell">
                                    <div className="customer-avatar"><i className="ph ph-user"></i></div>
                                    <div className="customer-info">
                                      <strong>{b.full_name || b.customer_id || "N/A"}</strong>
                                      <small>Customer</small>
                                    </div>
                                  </div>
                                </td>
                                <td>
                                  <div className="post-title-cell" title={b.post_title || "N/A"}>
                                    <strong>{this.truncateText(b.post_title)}</strong>
                                  </div>
                                </td>
                                <td>
                                  <div className="booking-date-cell">
                                    <div><i className="ph ph-sign-in"></i><span>{this.formatDate(b.checkin_date)}</span></div>
                                    <div><i className="ph ph-sign-out"></i><span>{this.formatDate(b.checkout_date)}</span></div>
                                  </div>
                                </td>
                                <td>
                                  <div className="amount-cell"><span className="currency">৳</span><strong>{this.formatCurrency(b.total_amount)}</strong></div>
                                </td>
                                <td>{this.bookingStatus(b.booking_status)}</td>
                                <td>{this.paymentStatus(b.payment_status)}</td>
                                <td>
                                  <div className="booking-actions">
                                    <button type="button" className="booking-action-btn edit" onClick={() => this.openModal("edit", b)} title="Edit Booking">
                                      <i className="ph ph-note-pencil"></i>
                                    </button>
                                    <button type="button" className="booking-action-btn delete" onClick={() => this.confirmDelete(b.id)} title="Delete Booking">
                                      <i className="ph ph-trash"></i>
                                    </button>
                                  </div>
                                </td>
                              </tr>
                            )) : (
                              <tr>
                                <td colSpan="8" className="booking-empty-cell">
                                  <div className="booking-empty-state">
                                    <div className="booking-empty-icon"><i className="ph ph-calendar-x"></i></div>
                                    <h5>{searchTerm ? "No matching bookings" : "No bookings found"}</h5>
                                    <p>
                                      {searchTerm
                                        ? "Try a different search term or clear the search."
                                        : "Add a new booking to see it here."}
                                    </p>
                                  </div>
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>

                      {totalItems > 0 && (
                        <div className="booking-pagination">
                          <div className="pagination-info">
                            Showing <strong>{startIndex + 1}</strong> to <strong>{endIndex}</strong> of <strong>{totalItems}</strong> bookings
                          </div>
                          <div className="pagination-controls">
                            <div className="items-per-page">
                              <span>Rows:</span>
                              <select value={itemsPerPage} onChange={this.handleItemsPerPageChange}>
                                <option value="10">10</option><option value="20">20</option><option value="30">30</option><option value="50">50</option>
                              </select>
                            </div>
                            <button type="button" className="pagination-btn" disabled={currentPage === 1} onClick={() => this.handlePageChange(currentPage - 1)}>
                              <i className="ph ph-caret-left"></i><span>Previous</span>
                            </button>
                            <div className="pagination-pages">
                              {this.getPageNumbers().map((page, index) => page === "..." ? (
                                <span className="pagination-ellipsis" key={`ellipsis-${index}`}>...</span>
                              ) : (
                                <button type="button" key={page} className={`pagination-page ${currentPage === page ? "active" : ""}`} onClick={() => this.handlePageChange(page)}>{page}</button>
                              ))}
                            </div>
                            <button type="button" className="pagination-btn" disabled={currentPage === totalPages} onClick={() => this.handlePageChange(currentPage + 1)}>
                              <span>Next</span><i className="ph ph-caret-right"></i>
                            </button>
                          </div>
                        </div>
                      )}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="modal fade booking-modal" id="bookingModal" tabIndex={-1} aria-hidden="true">
          <div className="modal-dialog modal-lg modal-dialog-centered">
            <div className="modal-content">
              <form onSubmit={this.handleSubmit}>
                <div className="modal-header booking-modal-header">
                  <div><span className="modal-kicker">BOOKING</span><h5 className="modal-title">{modalMode === "add" ? "Add New Booking" : "Edit Booking"}</h5></div>
                  <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div className="modal-body booking-modal-body">
                  <div className="row g-3">
                    <div className="col-md-6"><label className="booking-form-label">Select Post</label><select name="post_id" value={formData.post_id} onChange={this.handleChange} className="form-select booking-form-control" required><option value="">Choose post...</option>{posts.map((p) => <option key={p.id} value={p.id}>{p.title}</option>)}</select></div>
                    <div className="col-md-6"><label className="booking-form-label">Select Customer</label><select name="customer_id" value={formData.customer_id} onChange={this.handleChange} className="form-select booking-form-control" required><option value="">Choose customer...</option>{customers.map((c) => <option key={c.id} value={c.id}>{c.full_name}</option>)}</select></div>
                    <div className="col-md-6"><label className="booking-form-label">Check-in Date</label><input type="date" name="checkin_date" value={formData.checkin_date} onChange={this.handleChange} className="form-control booking-form-control" required /></div>
                    <div className="col-md-6"><label className="booking-form-label">Check-out Date</label><input type="date" name="checkout_date" value={formData.checkout_date} onChange={this.handleChange} className="form-control booking-form-control" required /></div>
                    <div className="col-md-4"><label className="booking-form-label">Rooms</label><input type="number" min="0" name="rooms" value={formData.rooms} onChange={this.handleChange} className="form-control booking-form-control" /></div>
                    <div className="col-md-4"><label className="booking-form-label">Adults</label><input type="number" min="0" name="adults" value={formData.adults} onChange={this.handleChange} className="form-control booking-form-control" /></div>
                    <div className="col-md-4"><label className="booking-form-label">Kids</label><input type="number" min="0" name="kids" value={formData.kids} onChange={this.handleChange} className="form-control booking-form-control" /></div>
                    <div className="col-md-6"><label className="booking-form-label">Booking Status</label><select name="booking_status" value={formData.booking_status} onChange={this.handleChange} className="form-select booking-form-control"><option value="pending">Pending</option><option value="confirmed">Confirmed</option><option value="cancelled">Cancelled</option></select></div>
                    <div className="col-md-6"><label className="booking-form-label">Payment Status</label><select name="payment_status" value={formData.payment_status} onChange={this.handleChange} className="form-select booking-form-control"><option value="unpaid">Unpaid</option><option value="paid">Paid</option></select></div>
                    <div className="col-12"><label className="booking-form-label">Total Amount</label><div className="amount-input-wrap"><span>৳</span><input type="number" step="0.01" min="0" name="total_amount" value={formData.total_amount} onChange={this.handleChange} className="form-control booking-form-control amount-input" placeholder="0.00" required /></div></div>
                    <div className="col-12"><label className="booking-form-label">Remarks</label><textarea name="remarks" value={formData.remarks} onChange={this.handleChange} className="form-control booking-form-control" rows="3" placeholder="Add booking notes..."></textarea></div>
                  </div>
                  {error && <div className="booking-modal-alert"><i className="ph ph-warning-circle"></i><span>{error}</span></div>}
                </div>
                <div className="modal-footer booking-modal-footer">
                  <button type="button" className="booking-secondary-btn" data-bs-dismiss="modal">Cancel</button>
                  <button type="submit" className="booking-primary-btn" disabled={submitting}>
                    {submitting ? <><span className="spinner-border spinner-border-sm" role="status"></span>Saving...</> : <><i className="ph ph-check"></i>{modalMode === "add" ? "Add Booking" : "Update Booking"}</>}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div className="modal fade booking-modal" id="deleteModal" tabIndex={-1} aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered modal-sm">
            <div className="modal-content delete-modal-content">
              <div className="modal-body delete-modal-body">
                <div className="delete-icon"><i className="ph ph-trash"></i></div>
                <h5>Delete Booking?</h5>
                <p>This booking record will be permanently removed.</p>
                <div className="delete-modal-actions">
                  <button type="button" className="booking-secondary-btn" data-bs-dismiss="modal">Cancel</button>
                  <button type="button" className="booking-danger-btn" onClick={this.handleDelete}>Delete</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Bookings;
